import Axios from './axios-instance';
import axios from 'axios';
import { navigateToUrl, registerApplication, start } from 'single-spa';

export const runScript = async (url) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        script.async = false;
        document.body.appendChild(script);
    });
};

export const matchingPathname = (pathnames) => (location) =>
    pathnames.some((pathname) => {
        return location.pathname.includes(pathname);
    });

export const getEnabledApps = async (orgId, config) => {
    let url = `/api/v3/organization/${orgId}/enabled-apps/`;
    try {
        let response = await axios({
            method: 'get',
            url: url,
            headers: config.headers,
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const loadApps = (apps, callback, appsDict, customProps) => {
    apps = apps.join(',');
    axios({
        method: 'get',
        url: `/single-spa/?apps=${apps}`,
    }).then((response) => {
        response.data.forEach((app) => {
            var node = document.createElement('DIV');
            node.id = app.name;
            document.getElementById('apps').appendChild(node);
            try {
                registerApplication(
                    // Name of single-spa application
                    app.name,
                    // loadingFunction
                    async () => {
                        await runScript(app.bundle);
                        return window[app.name];
                    },
                    // activityFunction
                    matchingPathname(app.routes),
                    // customProps
                    app.name === 'navigation'
                        ? {
                            Axios: Axios,
                            navigateToUrl: navigateToUrl,
                            apps: appsDict,
                        }
                        : {
                            Axios: Axios,
                            navigateToUrl: navigateToUrl,
                            customProps,
                            apps: appsDict,
                        },
                );
            } catch (error) {
                console.error(error);
            }
        });
        start();

        if (callback) {
            navigateToUrl(callback(window.location.pathname));
        }
    });
};

export function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
        //IE
        script.onreadystatechange = function() {
            if (
                script.readyState == 'loaded' ||
                script.readyState == 'complete'
            ) {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        //Others
        script.onload = function() {
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName('body')[0].appendChild(script);
}
